import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import Routes from './components/Routes'
import '@fortawesome/fontawesome-free/css/all.min.css';


// Pone la etiqueta de la pestana segun la base de datos del backend (Shaltex / Shaltex Mezclilla / Shaltex Pruebas)
try {
  const urlEntorno = (process.env.REACT_APP_URL_LOGIN || '').replace('/login', '/entorno');
  if (urlEntorno) {
    fetch(urlEntorno)
      .then((r) => r.json())
      .then((d) => { if (d && d.etiqueta) document.title = d.etiqueta; })
      .catch(() => {});
  }
} catch (e) {}


ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

